import { Injectable } from "@angular/core";
import { UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AccountService } from "src/app/shared/services/account/account.service";

@Injectable({
  providedIn: "root",
})
export class AdminGuard {
  constructor(private accountService: AccountService) {}

  canLoad():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.accountService.getAuthenticatedMember().pipe(
      map((member) => {
        if (member === null) {
          return this.accountService.createLoginUrlTree();
        }

        return member.is_orgadmin
          ? true
          : this.accountService.createMemberHomeUrlTree(member);
      }),
      catchError(() => of(this.accountService.createLoginUrlTree())),
    );
  }
}
